<div class="textWrapper">
  <p class="headingHead">
    {{title}}<i [class]="icon"></i>
  </p>
  <p class="bodyContent">{{txt}}</p>
</div>
<i class="icon-arrow"></i>
